<template>
  <panel title="物料库存" class="mgb10">
    <vxe-table
      :data="records"
      border
      size="small"
      :loading="loading"
      class="border-inner-top"
      auto-resize
      highlight-hover-row
      :scroll-y="{ enabled: false }"
    >
      <vxe-table-column
        field="warehouseName"
        :title="$t('menu.warehousesMms')"
      ></vxe-table-column>
      <vxe-table-column
        field="materialSerialNoQty"
        :title="$t('snapshoot.materialQty')"
      ></vxe-table-column>
      <vxe-table-column field="price" :title="$t('settlement.amount')">
        <template v-slot="{ row }"> {{ row.price | currency }}</template>
      </vxe-table-column>
    </vxe-table>
  </panel>
</template>

<script>
import InventoryMms from "@/api/inventoryMms.js";

export default {
  data() {
    return {
      loading: false,
      records: [],
    };
  },
  created() {
    const self = this;
    InventoryMms.existMaterialCount().then(function (res) {
      if (res.status === 200) {
        self.records = res.data;
      } else {
        self.sysError();
      }
    });
  },
};
</script>